class editUserCtrl {
    constructor($scope, logger, httpRequest, $state, $stateParams, formvalidateApi, $rootScope) {
        $scope.userType = $rootScope.userInfo.user.userType
        const userParams = $stateParams
        const { userId } = userParams
        //获取开票点信息
        const queryOrgInfo = function () {
            httpRequest.get_qryAssignUkeyList($scope.from.orgOwnership).then((res) => {
                $scope.allUkeyIdList = res.data.value
                for (const a in $scope.allUkeyIdList) {
                    if ($scope.isManager) {
                        $scope.allUkeyIdList[a].selected = true
                    } else {
                        $scope.allUkeyIdList[a].selected = false
                    }
                }

                // 修改状态
                for (let i = 0; i < $scope.from.ukeyIdList.length; i++) {
                    for (const b in $scope.allUkeyIdList) {
                        if ($scope.allUkeyIdList[b].ukeyId == $scope.from.ukeyIdList[i]) {
                            $scope.allUkeyIdList[b].selected = true
                        }
                    }
                }
            })
        }
        $scope.isManager = false
        const get_userInfo = function () {
            httpRequest.get_userInfo(userId).then((res) => {
                $scope.from = res.data.value
                // if($scope.from.userName = $scope.from.userMobile) $scope.usePhone = '1'
                getDepartmentList(res.data.value.orgOwnership)
                getRoleList(res.data.value.orgOwnership)
                $scope.from.roleList.forEach((item) => {
                    if (item.roleType == 2) $scope.isManager = true
                })
                queryOrgInfo()
            })
        }
        get_userInfo()
        $scope.$watch('isManager', () => {
            if ($scope.isManager) {
                for (const a in $scope.allUkeyIdList) {
                    $scope.allUkeyIdList[a].selected = true
                }
            }
        })
        $scope.$watch('s3item', () => {
            if ($scope.s3item && !$scope.s3item.length) {
                for (const a in $scope.allUkeyIdList) {
                    $scope.allUkeyIdList[a].selected = false
                }
            }
        })

        //获取部门
        const getDepartmentList = function getDepartmentList(orgOwnership) {
            let params = {
                pageNum: 0,
                pageSize: 10000,
                param: {
                    orgId: orgOwnership,
                },
            }
            httpRequest.post_qryDepartmentList(params).then((res) => {
                $scope.departmentList = res.data.value.list
            })
        }

        function toSelect2data(list, idfield, textfield) {
            const result = []
            for (const a in list) {
                const tempdata = {
                    id: '',
                    text: '',
                }
                $.extend(tempdata, list[a])
                tempdata.id = list[a][idfield]
                tempdata.text = list[a][textfield]
                result.push(tempdata)
            }
            return result
        }
        $scope.roleChange = (i) => {
            $scope.isManager = false
            $scope.taxpayerOptions3.data.forEach((item) => {
                i.split(',').forEach((id) => {
                    if (item.id == id && item.roleType == 2) $scope.isManager = true
                })
            })
        }
        $scope.updataUserInfo = function () {
            $scope.from.roleList = []
            $scope.from.ukeyIdList = []
            $scope.from.roleList = $scope.s3item.map((a) => {
                return {
                    orgId: a.orgId,
                    roleId: a.id,
                }
            })
            // for (const a in $scope.s3item) {
            //   $scope.from.roleList.push({
            //     orgId: $scope.s3item[a].orgId,
            //     roleId: $scope.s3item[a].id,
            //   })
            // }
            for (let i = 0; i < $scope.allUkeyIdList.length; i++) {
                if ($scope.allUkeyIdList[i].selected == true) {
                    $scope.from.ukeyIdList.push($scope.allUkeyIdList[i].ukeyId)
                }
            }
            $scope.from.usedPasswordDefault = Number($scope.from.usedPasswordDefault)
            const mark = formvalidateApi.run()
            const isArr = Boolean($scope.from.roleList.length)

            if (!isArr && !$scope.userType) {
                logger.logError('请选择角色')
                $scope.adduserInfo.usedPasswordDefault = Boolean($scope.adduserInfo.usedPasswordDefault)
            } else if ($scope.userType && roleList.length == 0) {
                logger.logError('请选择角色')
            } else if ((mark && isArr) || roleList.length > 0) {
                httpRequest.updata_userInfo($scope.from, '用户信息保存成功').then((res) => {
                    $scope.cancle()
                })
            } else {
            }
        }

        $scope.cancle = function () {
            if ($scope.userType == 0) {
                let search = encodeURI(
                    JSON.stringify({
                        orgIdList: [$scope.from.orgOwnership],
                    })
                )
                $state.go('system.permission.user.list', {
                    search,
                })
            } else {
                $state.go('system.permission.user.list')
            }
        }

        //获取角色
        const getRoleList = function getRoleList(orgId) {
            $scope.s3item = []
            $scope.taxpayerOptions3 = {
                data: [],
            }
            httpRequest.get_userOrgRole(orgId).then((res) => {
                $scope.taxpayerOptions3.placeholder = '请选择'
                let list = res.data.value
                if ($scope.userInfo.user.userType !== 0) {
                    list = list.filter((ele) => {
                        return ele.specialTag === '0'
                    })
                }
                const ret = toSelect2data(list, 'roleId', 'roleName')
                $scope.taxpayerOptions3.data = ret
                httpRequest.get_userInfo(userId).then((res) => {
                    for (let i = 0; i < $scope.from.roleList.length; i++) {
                        for (const a in $scope.taxpayerOptions3.data) {
                            if ($scope.from.roleList[i].roleId == $scope.taxpayerOptions3.data[a].id && $scope.from.roleList[i].orgId == orgId) {
                                $scope.s3item.push($scope.taxpayerOptions3.data[a])
                            }
                        }
                    }
                })
            })
        }

        // 电话校验规则
        $scope.validateRules = {
            userMobile: [
                {
                    erromsg: '手机号码格式错误',
                    condition(value) {
                        // 规则
                        const regex = /^[0-9]{11}$/

                        const result = (value == '') | (value == null) | regex.test(value)
                        // true 标示显示 errmsg  false 标示验证通过
                        return !result
                    },
                },
            ],
            realName: [
                {
                    erromsg: '限制20个字符以内',
                    condition(value) {
                        let result = true
                        if (value.length > 20) result = false
                        // true 标示显示 errmsg  false 标示验证通过
                        return !result
                    },
                },
            ],
            userEmail: [
                {
                    erromsg: '邮箱格式错误',
                    condition(value) {
                        // 规则
                        const regex = /^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/
                        let result = (value == '') | (value == null) | regex.test(value)
                        if (value && value.length > 50) result = false
                        // true 标示显示 errmsg  false 标示验证通过
                        return !result
                    },
                },
            ],
        }
        $scope.current = {
            deployType: localStorage.deployType,
            // usePhone :'1'
        }
        // $scope.$watch('usePhone',()=>{
        //     if($scope.usePhone == 1) $scope.from.userName = $scope.from.userMobile
        // })
        // $scope.$watch('from.userMobile',()=>{
        //     if($scope.usePhone == 1) $scope.from.userName = $scope.from.userMobile
        // })
        $scope.orgOwnership = sessionStorage.getItem('orgOwnership') // 用户所属机构id
        // 用户所有的机构
        //let userAllOrgList = $scope.userType ? JSON.parse(localStorage.getItem('orgList')) : JSON.parse(localStorage.getItem('user_info')).orgList
        // console.log($rootScope)
        // $scope.orgList = $rootScope.loginOrgList

        httpRequest.get_getUserOrgListByUserId($rootScope.userInfo.user.userId, $rootScope.userInfo.user.userType).then((res) => {
            $scope.orgList = res.data.value
            let roleList = JSON.parse(sessionStorage.getItem('roleList')) // 用户所有的角色
            let ukeyList = JSON.parse(sessionStorage.getItem('ukeyList')) // 用户所有的ukey
            for (const org of $scope.orgList) {
                if (!!roleList) {
                    org.roleList = []
                    for (const ukey of roleList) {
                        if (org.orgId == ukey.orgId) {
                            org.roleList.push(ukey.roleName)
                        }
                    }
                } else {
                    org.roleList = []
                }
                if (!!ukeyList) {
                    org.ukeyList = []
                    for (const ukey of ukeyList) {
                        if (org.orgId == ukey.orgId) {
                            org.ukeyList.push(ukey.ukeyName)
                        }
                    }
                } else {
                    org.ukeyList = []
                }
            }
        })
    }
}
editUserCtrl.$inject = ['$scope', 'logger', 'httpRequest', '$state', '$stateParams', 'formvalidateApi', '$rootScope']
export default editUserCtrl



// WEBPACK FOOTER //
// ./src/app/system/permission/user/edit_userCtrl.js